// import React, { createContext, useContext, useReducer,useEffect } from 'react';
// import toastService from '../../utils/toastService';
// import { useTranslation } from "react-i18next";
// import translations from "../../utils/language/translations.json";
// import axios from "axios";
// import { UserContext } from '../login/LoginForm';

// import { AuthContext } from "../login/AuthContext";
// const CartContext = createContext();

// const initialState = { items: [] };

// function cartReducer(state, action) {
//     switch (action.type) {
//         case 'ADD_ITEM':
//             return { ...state, items: [...state.items, action.payload] };
//         case 'ADD_ADDITIONAL_ITEMS':
//             return { items: [...state.items, ...action.payload] };
//         case 'REMOVE_ITEM':
//             return { ...state, items: state.items.filter(item => item.userCardId !== action.payload) };
//         case 'REMOVE_ALL_ITEMS_BY_SELLER':
//             return { ...state, items: state.items.filter(item => item.sellerId !== action.sellerId) };
//         case 'CHECKOUT':
//             return { ...state, items: state.items.filter(item => item.sellerId !== action.sellerId) };
//         case 'CLEAR_CART':
//             return { items: [] };
//         default:
//             return state;
//     }
// }

// export const CartProvider = ({ children }) => {
//     const [state, dispatch] = useReducer(cartReducer, initialState);
//     const { userId,liveCsrfToken } = useContext(AuthContext);
//     const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
//     const currentLang = i18n.language; // Access the current language
//     const t = (key) => translations.Cart[key][currentLang]; // Adjust the path according to your JSON structure
// import toastService from '../../utils/toastService';
//     const toast = toastService(t);
//      // Replace this with your actual userId handling

   



//     const addItem = async (item) => {
//         const itemExists = state.items.some(cartItem => cartItem.userCardId === item.userCardId);

//         if (!itemExists) {
//             try {
               
//                 dispatch({ type: 'ADD_ITEM', payload: item });
//                 toast.success('Item(s) successfully added to your cart.');
//             } catch (error) {
//                 toast.error('Error adding item to cart.');
//                 console.error('Error adding item to cart:', error);
//             }
//         } else {
//             toast.error('This item is already in your cart.');
//         }
//     };


//      // Add multiple items to cart
//   const addAdditionalItems = items => {
//     const existingIds = state.items.map(item => item.userCardId);
//     const newItems = items.filter(item => !existingIds.includes(item.userCardId));
//     const duplicateItems = items.filter(item => existingIds.includes(item.userCardId));

//     if (newItems.length > 0) {
//       dispatch({ type: 'ADD_ADDITIONAL_ITEMS', payload: newItems });
//       toast.success(`${newItems.length} item(s) successfully added to your cart.`);
//     }

//     if (duplicateItems.length > 0) {
//       toast.info(`${duplicateItems.length} item(s) were already in your cart and were not added again.`);
//     }
//   };


//     const removeItem = userCardId => {
//         // Check if the item exists in the cart
//         const itemExists = state.items.some(cartItem => cartItem.userCardId === userCardId);
    
//         if (itemExists) {
//             dispatch({ type: 'REMOVE_ITEM', payload: userCardId });
//             toast.success('Item(s) successfully removed from your cart.')
//         } else {
//             toast.error("This item is not in your cart."); // This item is not in your cart.
//         }
//     };
//     const removeAllItemsBySeller = sellerId => {
//         const itemsExist = state.items.some(cartItem => parseInt(cartItem.SellerId) === parseInt(sellerId));
//         if (itemsExist) {
//             dispatch({ type: 'REMOVE_ALL_ITEMS_BY_SELLER', SellerId: sellerId });
//             toast.success('Item(s) from this seller have been removed.')
//         } else {
//             toast.error("There are no items from this seller in your cart.");
//         }
//     };


//      // Clear entire cart
//   const clearCart = () => {
//     dispatch({ type: 'CLEAR_CART' });
//     toast.success('All items have been removed from your cart.');
//   };
      
//     const checkout = sellerId => {
//         dispatch({ type: 'CHECKOUT', sellerId: sellerId });
//         alert('Checkout process initiated for seller: ' + sellerId);
//         // Here you might integrate actual payment processing logic or redirection
//     };

//     return (
//         <CartContext.Provider value={{  cart: state.items,addItem,addAdditionalItems,removeItem,removeAllItemsBySeller,clearCart,checkout, }}>
//             {children}
//         </CartContext.Provider>
//     );
// };

// export const useCart = () => {
//     const context = useContext(CartContext);
//     if (context === undefined) {
//         throw new Error('useCart must be used within a CartProvider');
//     }
//     return context;
// };



import React, { createContext, useContext, useReducer, useEffect } from 'react';
import toastService from '../../utils/toastService';
import { useTranslation } from "react-i18next";
import translations from "../../utils/language/translations.json";
import axios from "axios";
import { AuthContext } from "../login/AuthContext";

const CartContext = createContext();
const initialState = { items: [] };

function cartReducer(state, action) {
    switch (action.type) {
        case 'ADD_ITEM':
            return { ...state, items: [...state.items, action.payload] };
        case 'ADD_ADDITIONAL_ITEMS':
            return { items: [...state.items, ...action.payload] };
        case 'REMOVE_ITEM':
            return { ...state, items: state.items.filter(item => item.userCardId !== action.payload) };
        case 'REMOVE_ALL_ITEMS_BY_SELLER':
            return { ...state, items: state.items.filter(item => item.sellerId !== action.sellerId) };
        case 'CHECKOUT':
            return { ...state, items: state.items.filter(item => item.sellerId !== action.sellerId) };
        case 'CLEAR_CART':
            return { items: [] };
        default:
            return state;
    }
}

export const CartProvider = ({ children }) => {
    const [state, dispatch] = useReducer(cartReducer, initialState);
    const { userId, liveCsrfToken } = useContext(AuthContext);
    const { t: translate, i18n } = useTranslation();
    const currentLang = i18n.language;
    const t = (key) => translations.Cart[key][currentLang];
    const toast = toastService(t);

    useEffect(() => {
        const fetchCartItems = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/cart`, { 
                    params: { userId },
                    withCredentials: true, 
                    headers: { 'x-csrf-token': liveCsrfToken }
                });
                
                // Extract cart items from the response
                const fetchedItems = response.data;
                console.log('fetchedItems',fetchedItems)
                // Get the IDs of items currently in the cart
                const existingItemIds = state.items.map(item => item.userCardId);
    
                // Filter to include only new items not already in the cart
                const newItems = fetchedItems.filter(item => !existingItemIds.includes(item.userCardId));
    
                // Dispatch only if there are new items
                if (newItems.length > 0) {
                    dispatch({ type: 'ADD_ADDITIONAL_ITEMS', payload: newItems });
                }
            } catch (error) {
                console.error('Error fetching cart items:', error);
            }
        };
    
        if (userId) {
            fetchCartItems();
        }
    }, [userId, liveCsrfToken, state.items]); // Add state.items as a dependency
    

    const addItem = async (item) => {
        console.log('202 item',item)
        const itemExists = state.items.some(cartItem => cartItem.userCardId === item.userCardId);
        if (!itemExists) {
            try {
                await axios.post(`${process.env.REACT_APP_API_BASE}/api/cart/add`, 
                    { ...item, liveCsrfToken,userId }, 
                    { 
                        withCredentials: true, 
                        headers: { 'x-csrf-token': liveCsrfToken }
                    }
                );
                dispatch({ type: 'ADD_ITEM', payload: item });
                toast.success('Item(s) successfully added to your cart.');
            } catch (error) {
                toast.error('Error adding item to cart.');
                console.error('Error adding item to cart:', error);
            }
        } else {
            toast.error('This item is already in your cart.');
        }
    };

   // Add multiple items to cart
const addAdditionalItems = async (items) => {
    const existingIds = state.items.map(item => item.userCardId);
    const newItems = items.filter(item => !existingIds.includes(item.id));
    const duplicateItems = items.filter(item => existingIds.includes(item.id));
    console.log('duplicateItems',duplicateItems)
    console.log('existingIds',existingIds)
    
    console.log('newItems',newItems)
    if (newItems.length > 0) {
        try {
            await axios.post(
                `${process.env.REACT_APP_API_BASE}/api/cart/add-bulk`,
                { items: newItems, liveCsrfToken, userId },
                { withCredentials: true, headers: { 'x-csrf-token': liveCsrfToken } }
            );

            dispatch({ type: 'ADD_ADDITIONAL_ITEMS', payload: newItems });
            toast.success(`item(s) successfully added to your cart.`);
        } catch (error) {
            toast.error('Error adding multiple items to cart.');
            console.error('Error adding multiple items to cart:', error);
        }
    }

    if (duplicateItems.length > 0) {
        toast.info(`item(s) were already in your cart and were not added again.`);
    }
};

// Remove a single item from cart
const removeItem = async (userCardId) => {
    const itemExists = state.items.some(cartItem => cartItem.userCardId === userCardId);
    if (itemExists) {
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE}/api/cart/remove`, {
                data: { userId, userCardId, liveCsrfToken },
                withCredentials: true,
                headers: { 'x-csrf-token': liveCsrfToken }
            });
            dispatch({ type: 'REMOVE_ITEM', payload: userCardId });
            toast.success('Item(s) successfully removed from your cart.');
        } catch (error) {
            toast.error('Error removing item from cart.');
            console.error('Error removing item from cart:', error);
        }
    } else {
        toast.error("This item is not in your cart.");
    }
};

// Remove all items from a specific seller in the cart
const removeAllItemsBySeller = async (sellerId) => {
    const itemsExist = state.items.some(cartItem => parseInt(cartItem.SellerId) === parseInt(sellerId));
    if (itemsExist) {
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE}/api/cart/remove-by-seller`, {
                data: { userId, sellerId, liveCsrfToken },
                withCredentials: true,
                headers: { 'x-csrf-token': liveCsrfToken }
            });
            dispatch({ type: 'REMOVE_ALL_ITEMS_BY_SELLER', payload: sellerId });
            toast.success('Item(s) from this seller have been removed.');
        } catch (error) {
            toast.error('Error removing seller items from cart.');
            console.error('Error removing seller items from cart:', error);
        }
    } else {
        toast.error("There are no items from this seller in your cart.");
    }
};

// Clear the entire cart
const clearCart = async () => {
    try {
        await axios.delete(`${process.env.REACT_APP_API_BASE}/api/cart/clear`, {
            data: { userId, liveCsrfToken },
            withCredentials: true,
            headers: { 'x-csrf-token': liveCsrfToken }
        });
        dispatch({ type: 'CLEAR_CART' });
        toast.success('All items have been removed from your cart.');
    } catch (error) {
        toast.error('Error clearing the cart.');
        console.error('Error clearing the cart:', error);
    }
};

    const checkout = sellerId => {
        dispatch({ type: 'CHECKOUT', sellerId });
        alert('Checkout process initiated for seller: ' + sellerId);
    };

    return (
        <CartContext.Provider value={{ cart: state.items, addItem, addAdditionalItems, removeItem, removeAllItemsBySeller, clearCart, checkout }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    const context = useContext(CartContext);
    if (context === undefined) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};
